import React from 'react';
import { Navigate } from 'react-router-dom';
import { LOGIN_DOMAIN_KEY, rotaLogin } from './Login';
import { getAuthSlug, hasAuthToken } from '../services/authStorage';

const ProtectedRoute = ({ children }) => {
  if (hasAuthToken()) return children;

  const slug = getAuthSlug() || localStorage.getItem(LOGIN_DOMAIN_KEY);
  return <Navigate to={rotaLogin(slug)} replace />;
};

export default ProtectedRoute;
